export default {
    info: {
        is_official_open: 'Whether the website is officially open',
        open: 'Open',
        close: 'Close',
        please_select_open_status: 'Please select whether to open the website',
        footer_content: 'Website footer content',
        please_enter_footer_content: 'Please enter the website footer content',
        save: 'Save'
    },
    style: {
        template_select: 'Template selection',
        background_color: 'Background color',
        background_color_required: 'Background color cannot be empty',
        theme_color: 'Theme color',
        theme_color_required: 'Theme color cannot be empty',
        nav_color_select: 'Navigation color selection',
        nav_home: 'Home',
        nav_basic_info: 'Basic Information',
        nav_organization: 'Organization',
        nav_submission: 'Essay Submission',
        nav_schedule: 'Academic Schedule',
        nav_registration: 'Conference Registration',
        nav_hotel: 'Hotel & Transportation',
        nav_contact: 'Contact Us',
        nav_bg_color: 'Navigation background color selection',
        nav_selected_color: 'Navigation selected color selection',
        nav_selected_font_color: 'Navigation selected font color selection',
        nav_font_color: 'Navigation font color selection',
        save: 'Save'
    },
    page_content: {
        content_status_show: 'Show',
        content_status_hide: 'Hide',
        edit_content: 'Edit',
        manage_content: 'Manage content',
        nav_name: 'Navigation name',
        nav_type: 'Column type',
        content_hidden: 'Whether to hide',
        content_operation: 'Operation',
        type_not_supported: 'This type is not supported yet',
        nav_edit: 'Column edit',
        nav_id: 'Column ID'
    },
    nav_list: {
        add_nav: 'Add new',
        nav_status_show: 'Show',
        nav_status_hide: 'Hide',
        add_sub_nav: 'Add sub - column',
        edit_nav: 'Edit',
        manage_content: 'Manage content',
        delete_nav: 'Delete',
        nav_sort: 'Sort',
        nav_menu: 'Navigation menu',
        nav_type: 'Column type',
        nav_hidden: 'Whether to hide',
        nav_operation: 'Operation',
        confirm_delete: 'Are you sure you want to delete [',
        confirm_delete_end: ']?',
        new_nav: 'New column',
        registration_notice: 'Conference participation notice',
        module_name: 'Column name',
        please_enter_module_name: 'Please enter the column name',
        module_type: 'Column type',
        please_select_module_type: 'Please select the column type',
        subtitle: 'Subtitle',
        is_show: 'Whether to show',
        yes: 'Yes',
        no: 'No',
        select_time: 'Select time',
        please_select_time: 'Please select the time',
        content: 'Content',
        please_enter_content: 'Please enter the content',
        jump_link: 'Jump link',
        is_anonymous_message: 'Whether to leave an anonymous message',
        please_select_is_anonymous_message: 'Please select whether to leave an anonymous message',
        open_new_page: 'Whether to open in a new page',
        please_select_open_new_page: 'Please select whether to open in a new page',
        sort: 'Sort',
        please_enter_sort: 'Please enter the sort',
        display_count: 'Display count',
        sort_tip: 'Default is 10',
        submit: 'Submit immediately',
        module_edit: 'Column edit',
        please_select_is_show: 'Please select whether to show'
    },
    button_list: {
        add_button: 'Add new shortcut',
        edit: 'Edit',
        delete: 'Delete',
        confirm_delete: 'Are you sure you want to delete?',
        title: 'Title',
        subtitle: 'Subtitle',
        link: 'Link',
        sort: 'Sort',
        open_new_page: 'Whether to open in a new page',
        operation: 'Operation',
        yes: 'Yes',
        no: 'No',
        icon: 'Icon',
        url:'Link',
        create_time:'Create Time',
        display:'Display'
    },
    button_info: {
        title_type: 'Title type',
        title: 'Title',
        subtitle: 'Subtitle',
        link: 'Link',
        link_tip: 'Please enter a link starting with http:// or https://',
        sort: 'Sort',
        open_new_page: 'Whether to open in a new page',
        please_select_open_new_page: 'Please select whether to open in a new page',
        submit: 'Submit immediately',
        clear: 'Clear'
    },
    image_info: {
        title: 'Title',
        please_enter_title: 'Please enter the title',
        subtitle: 'Subtitle',
        upload_image: 'Upload image',
        image_tip: 'Supports JPG, GIF, PNG image files, and the file size cannot exceed 2M',
        link: 'Link',
        link_tip: 'Please enter a link starting with http:// or https://',
        sort: 'Sort',
        open_new_page: 'Whether to open in a new page',
        please_select_open_new_page: 'Please select whether to open in a new page',
        submit: 'Submit immediately',
        only_image_files: 'You can only upload image files',
        upload_image_mobile: 'Mobile - end image'
    },
    image_list: {
        add_image: 'Add new image',
        copyright_notice: 'To avoid image copyright disputes, you can upload pictures from previous conferences. Be sure to avoid uploading online scenic or city photos without authorization.',
        edit: 'Edit',
        delete: 'Delete',
        sort: 'Sort',
        title: 'Title',
        image: 'Image',
        create_time: 'Creation time',
        operation: 'Operation',
        image_list: 'Image list',
        confirm_delete_item: 'Are you sure you want to delete [{title}]?',
        yes: 'Yes',
        no: 'No'
    },
    news_info: {
        add: 'Add new',
        title: 'Title',
        please_enter_title: 'Please enter the title',
        source: 'Source',
        description: 'Description',
        title_style: 'Title style',
        bold: 'Bold',
        highlight: 'Highlight',
        new_icon: 'New icon',
        hot_icon: 'Hot icon',
        upload_image: 'Upload image',
        image_tip: 'Supports JPG, GIF, PNG image files, and the file size cannot exceed 2M',
        clear: 'Clear',
        sort: 'Sort',
        external_link: 'External link',
        link_tip: 'Please enter a link starting with http:// or https://',
        content: 'Content',
        please_enter_content: 'Please enter the content',
        submit: 'Submit immediately',
        only_image_files: 'You can only upload image files'
    },
    news_list: {
        add_news: 'Add new news',
        show: 'Show',
        hide: 'Hide',
        edit: 'Edit',
        delete: 'Delete',
        sort: 'Sort',
        title: 'Title',
        creator: 'Creator',
        show_hide: 'Show|Hide',
        create_time: 'Creation time',
        operation: 'Operation',
        news_list: 'News list',
        confirm_delete_item: 'Are you sure you want to delete [{title}]?'
    },
    guest_info: {
        add: 'Add new',
        name: 'Name',
        please_enter_name: 'Please enter the name',
        photo: 'Photo',
        photo_tip: '150*150px, supports JPG, GIF, PNG image files. Files larger than 500K will be automatically compressed.',
        upload_photo: 'Upload photo',
        clear: 'Clear',
        company: 'Company',
        title: 'Title',
        position: 'Position',
        sort: 'Sort',
        external_link: 'External link',
        link_tip: 'Please enter a link starting with http:// or https://',
        introduction: 'Introduction',
        please_enter_content: 'Please enter the content',
        submit: 'Submit immediately',
        only_image_files: 'You can only upload image files'
    },
    guest_list: {
        add_guest: 'Add new guest speaker',
        edit: 'Edit',
        delete: 'Delete',
        sort: 'Sort',
        name: 'Name',
        title: 'Title',
        position: 'Position',
        creator: 'Creator',
        create_time: 'Creation time',
        operation: 'Operation',
        guest_list: 'Guest speakers',
        confirm_delete_item: 'Are you sure you want to delete [{name}]?'
    },
    formConfig: {
        only_upload_image: 'You can only upload image files',
        upload_error: 'Upload failed'
    },
    loading: 'Loading...'
};
